// extracted by mini-css-extract-plugin
export var closeButton = "_1f-3";
export var header = "_1f-0";
export var link = "_1f-1";
export var retryButton = "_1f-2";